import forgotPasswordService from '@/services/forgot-password.js'

const forgotPasswordHandler = {
  state: {
  },

  mutations: {
  },

  actions: {
    async ACTION_SEND_VERIFICATION_LINK (context, payload) {
      let req = await forgotPasswordService.sendVerificationLink(payload)
      return Promise.resolve(req)
    },
    async ACTION_VERIFY_EMAIL_FOR_FORGOT_PASSWORD (context, payload) {
      let req = await forgotPasswordService.verifyEmail(payload)
      return Promise.resolve(req)
    },
    async ACTION_RESET_PASSWORD (context, payload) {
      let req = await forgotPasswordService.resetPassword(payload)
      return Promise.resolve(req)
    },
    async ACTION_RESEND_VERIFICATION_LINK (context, payload) {
      let req = await forgotPasswordService.resendVerificationLink(payload)
      return Promise.resolve(req)
    },
  },

  getters: {
  }
}

export default forgotPasswordHandler
